import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import HideValue from '../../components/Common/RestrictedAccess/HideValue';

/**
 * h3Text custom component
 *
 */
export default function H3Text({
  isInternalLink,
  isExternalLink,
  className,
  text,
  internalUrl,
  externalUrl,
  onClick,
  required,
  style,
  infoMessage,
  infoMessageStyle = {
    marginLeft: '5px',
    color: 'grey',
    cursor: 'pointer',
  },
  hideText,
  popOverMessage,
  id,
}) {
  return (
    <div className={className} style={style} onClick={onClick} id={id}>
      { (isInternalLink || isExternalLink)
        ? (
          <Link to={internalUrl || externalUrl}>
            {hideText ? <HideValue showPopOver popOverMessage={popOverMessage} /> : text}
          </Link>
        )
        : (hideText ? <HideValue showPopOver popOverMessage={popOverMessage} /> : text)}
      { required && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
      {infoMessage && (
        <Tooltip title={infoMessage}>
          <InfoCircleOutlined
            style={infoMessageStyle}
          />
        </Tooltip>
      )}
    </div>
  );
}

H3Text.propTypes = {
  isInternalLink: PropTypes.bool,
  isExternalLink: PropTypes.bool,
  className: PropTypes.string,
  text: PropTypes.any,
  internalUrl: PropTypes.string,
  externalUrl: PropTypes.string,
  onClick: PropTypes.func,
  required: PropTypes.bool,
  style: PropTypes.object,
  infoMessage: PropTypes.object,
  infoMessageStyle: PropTypes.object,
};
